import { gql } from '@apollo/client';

/**
 * GraphQL documents for community-related operations
 */
export const GET_COMMUNITY_OPTIONS = gql`
  query GetCommunityOptions {
    communityOptions {
      contentGenres {
        name
        value
        description
      }
      pgRatings {
        name
        value
        description
      }
    }
  }
`;
